import {
  AddOutlined,
  CancelOutlined,
  Edit,
  ExpandMore,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { FormikValues, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  ApiCreateVenueLogins,
  ApiGenerateLoginToken,
  ApiGetREgionListByClientEntity,
  ApiGetVenueByVenueId,
  ApiGetVenueList,
  ApiGetVenueLogins,
  ApiPutUpdateVenue,
  ApiRegionVenues,
  ApiUpdateVenueLogins,
} from "../../apiService/Core/Apicall";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../global/config/Reducer";
import { veneuLogins } from "../../apiService/Core/ApiEndPoint";
import { RegionList, setRegion } from "../../global/config/Reducer/RegionSlice";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import storage from "../../utils/storage";

function ManageVenue() {
  const [selectedId, setselectedId] = useState(0);
  const [selectedmanager, setselectedmanager] = useState(0);
  const [searchVenue, setsearchVenue] = useState<string>("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isOpenAdd, setisOpenAdd] = useState(false);
  const [isedit, setisedit] = useState(false);
  const [venuelist, setvenuelist] = useState<any[]>([]);
  const [venuemanagerlist, setvenuemanagerlist] = useState<any[]>([]);
  const clientEntity = useSelector(
    (state: RootState) => state.clientEntity.selectedEntity
  );
  const userData = JSON.parse(storage.getItem("userData") || "{}");
  const Regions = useSelector(RegionList);
  const dispatch = useDispatch();
  const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '');
  const [venue, setVenue] = useState<any>(null);
  const [regionBusiness, setRegionBusiness] = useState<any>();
  const [isGroupScore, setisGroupScore] = useState<boolean>(false);
  const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
  const [venueData, setVenueData] = useState<any>({
    venueName: "",
    regionId: "",
    directorName: "",
    locationType: "city", // default metro
    address: "",
    lat: "",
    long: "",
    isAldiLiquor: false,
    venueOpen: "",
    venueClose: "",
  });
  const inputRef = useRef<HTMLInputElement>(null);
  const autocompleteRef = useRef<any>(null);
  const setFieldValueRef = useRef<any>(null);

  // Generic change handler
  const handleVenueChange = (field: string, value: any) => {
    setVenueData((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const center = {
    lat: -25.2744,
    lng: 133.7751,
  };
  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44",
    libraries: ["places"],
  });

  useEffect(() => {
    const RegionList = async () => {
      if (
        storage.getItem("clientEntityId") &&
        storage.getItem("ClientGroupName") === "ALDI"
      ) {
        const data = `?clientEntityId=${storage.getItem(
          "clientEntityId"
        )}`;
        const response3 = await ApiRegionVenues(data);
        dispatch(setRegion(response3.data));
      }
      const data = `?clientEntityId=${storage.getItem("clientEntityId")}`;
      const response = await ApiGetREgionListByClientEntity(data);
      setRegionBusiness(response.data);
      if (!isLoaded) {
        return <div>Loading Map...</div>;
      }
    };
    RegionList();
  }, [clientEntity]);

  useEffect(() => {
    if (!isLoaded || !inputRef.current) return;

    if (isLoaded && window.google && inputRef.current) {
      try {
        autocompleteRef.current = new window.google.maps.places.Autocomplete(
          inputRef.current,
          {
            types: ["geocode"],
            componentRestrictions: { country: "AU" },
          }
        );

        autocompleteRef.current.addListener("place_changed", () => {
          const place = autocompleteRef.current.getPlace();

          if (!place || !place.formatted_address) {
            console.warn("No address found.");
            return;
          }

          handleVenueChange("address", place.formatted_address);

          if (place.geometry?.location) {
            handleVenueChange("lat", place.geometry.location.lat());
            handleVenueChange("long", place.geometry.location.lng());
          }
        });
      } catch (error) {
        console.error("Error initializing autocomplete:", error);
      }
    }
  }, [isLoaded]);

  useEffect(() => {
    if (Regions.length > 0) {
      setselectedRegion(Regions[0].regionId);
    }
  }, [Regions, clientEntity]);

  useEffect(() => {
    const Venuelist = async () => {
      if (!window.location.hostname.includes("aldi")) {
        try {
          const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem("clientEntityId");
          const response = await ApiGetVenueList(clientEntityId);

          if (response?.data && response.data.length > 0) {
            setvenuelist(response.data);

            // Make sure selectedId points to a valid venue
            const currentId = selectedId ?? 0; // fallback to first venue if null
            if (response.data[currentId]?.venueId) {
              const data = `?venueId=${response.data[selectedId].venueId}&offset=0&limit=10`;
              const venueResponse = await ApiGetVenueByVenueId(data);
              setVenueData(venueResponse.data[0]);
            }
          }
        } catch (error: any) {
          // toast.error(error)
        }
      } else {
        const finalregion =
          Regions &&
          Regions.find((region: any) => region.regionId === selectedRegion)
            ?.venues;
        setvenuelist(finalregion);
        const currentId = selectedId ?? 0; // fallback to first venue if null
        const data = `?venueId=${finalregion?.[selectedId]?.venueId}&offset=0&limit=10`;
        const venueResponse = await ApiGetVenueByVenueId(data);
        setVenueData(venueResponse.data[0]);

      }
    };
    clientEntity && Venuelist();
  }, [clientEntity, selectedRegion, Regions, isGroupScore]);


  const venuelogins = async () => {
    try {
      const data = `?venueId=${venuelist[selectedId].venueId}`;
      const res = await ApiGetVenueLogins(data);
      if (res.status) {
        setvenuemanagerlist(res.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    venuelist && venuelogins();
  }, [venuelist, selectedId]);

  const initialValues = {
    venueId: venuelist?.[selectedId]?.venueId ?? "",
    emailId: isedit ? venuemanagerlist[selectedmanager]?.emailId : "",
    password: "",
    confirmpassword: "",
    // roleId: 4,
    firstName: isedit ? venuemanagerlist[selectedmanager]?.firstName : "",
    lastName: isedit ? venuemanagerlist[selectedmanager]?.lastName : "",
    contactNo: isedit ? venuemanagerlist[selectedmanager]?.contactNo : "",
    createdBy: userData.userId,
    isedit: isedit,
  };

  const validationSchema = Yup.object({
    emailId: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),

    password: Yup.string().when("isedit", {
      is: false,
      then: schema =>
        schema
          .required("Password is required")
          .min(6, "Password must be at least 6 characters")
          .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
          .matches(/[0-9]/, "Password must contain at least one number"),
      otherwise: schema => schema.notRequired()
    }),

    confirmpassword: Yup.string().when("isedit", {
      is: false,
      then: schema =>
        schema
          .required("Confirm Password is required")
          .oneOf([Yup.ref("password")], "Passwords must match"),
      otherwise: schema => schema.notRequired()
    }),

    firstName: Yup.string().required("First Name is required"),

    lastName: Yup.string().required("Last Name is required"),

    // contactNo: Yup.string()
    //   .required("Contact Number is required")
    //   .matches(/^[0-9]{10}$/, "Contact Number must be 10 digits"),
  });

  const onSubmit = async (values: FormikValues) => {
    const updatevalues = {
      userId: venuemanagerlist[selectedmanager]?.userId,
      // password: values.password,
      displayName: `${values.firstName} ${values.lastName}`,
      // roleId: 4,
      firstName: values.firstName,
      lastName: values.lastName,
      contactNo: values.contactNo,
      updatedBy: values.createdBy,
    };
    try {
      const response = isedit
        ? await ApiUpdateVenueLogins(updatevalues)
        : await ApiCreateVenueLogins(values);
      if (response.status) {
        formik.resetForm();
        // isedit
        // ? toast.success("Details updated successfully")
        // : toast.success("VenueManager added successfully");
        setisedit(false);
        setisOpenAdd(false);
        venuelogins();
      }
    } catch (error: any) {
      console.log("Error", error)
      const message =
        error?.response?.data?.message || error?.message || String(error);
      toast.error(message);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit,
  });

  const handleVenueClick = async (item: any, index: any) => {
    setselectedId(index);
    const data = `?venueId=${item?.venueId}&offset=0&limit=10`;
    const response = await ApiGetVenueByVenueId(data);
    setVenueData(response.data[0]);
  };

  const handleSaveVenue = async (venueData: any) => {
    const FormData = {
      venueId: venueData?.venueId,
      address: venueData?.address,
      regionId: venueData?.regionId?.regionId,
      locationType: venueData?.locationType, // default metro
      lat: venueData?.lat,
      long: venueData?.long,
      isAldiLiquor: venueData?.isAldiLiquor,
      venueOpen: venueData?.venueOpen,
      venueClose: venueData?.venueClose,
      venueCode: venueData?.venueCode,
      shopTypeId: venueData?.shopTypeId?.shopTypeId,
      clientEntityId: venueData?.clientEntityId?.clientEntityId,
      logoUrl: venueData?.logoUrl,
      updatedBy: 1,
      venueName: venueData?.venueName,
      directorName: venueData?.directorName
    };
    const response = await ApiPutUpdateVenue(FormData);
    // toast.success("Venue updated successfully!");
  };

  const formatDateTimeLocal = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
  };



  const getClientSiteURL = (hostname: any) => {
    switch (hostname) {
      case "ALDI":
        return process.env.REACT_APP_API_ALDI;
      case "BLOOMS":
        return process.env.REACT_APP_API_BLOOMS;
      case "MM":
      case "TRANSPORT": // same URL for both
        return process.env.REACT_APP_API_COMMON;
      default:
        return null;
    }
  }
  const navigateToLoginShopper = async (user: any) => {

    try {
      const data = {
        adminUserId: userData?.userId,
        targetUserId: user.userId,
        ipAddress: '127.0.0.1',
        browserName: 'Google chrome'

      }
      const res = await ApiGenerateLoginToken(data)
      if (res.success) {
        // alert("Login")
        window.open(`${getClientSiteURL(storage.getItem('ClientGroupName'))}?adminuserid=${userData?.userId}&validation=${res.data.token}`, '_blank');
      }
    } catch (error: any) {
      toast.error(error)
    }

  }

  return (
    <Box className="w-100" >
      {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
        <Box className='d-flex justify-content-end mb-1'>
          <FormControlLabel
            control={
              <Switch
                checked={isGroupScore}
                onChange={(e) => setisGroupScore(e.target.checked)}
              />
            }
            label={"Whole Group"}
          />
        </Box>)}
      <Grid container height={"calc(100% - 100px)"} spacing={3}>
        <Grid
          size={{ xs: 12, md: 4 }}
          className="h-100"
          overflow={"auto"}
          position={"relative"}>
          <Box
            className="mb-3 d-flex align-items-end justify-content-between"
            gap={4}>
            <FormControl fullWidth className="rm-padding">
              <FormLabel sx={{ fontSize: "14px" }}>Search By Name</FormLabel>
              <TextField
                value={searchVenue}
                className="w-100 border-20"
                onChange={(e) => {
                  setsearchVenue(e.target.value);
                }}></TextField>
            </FormControl>
            {window.location.hostname.includes("aldi") && (
              <FormControl
                sx={{ width: "auto", minWidth: "200px", height: "fit-content" }}>
                <InputLabel id="demo-simple-select-label">Region</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="Region"
                  id="demo-simple-select"
                  defaultValue={Regions[0]?.regionId}
                  value={selectedRegion}
                  onChange={(e: any) => {
                    setselectedRegion(e.target.value);
                  }}>
                  {Regions?.map((item: any, index: number) => (
                    <MenuItem key={index} value={item.regionId}>
                      {item.regionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
          {venuelist
            ?.filter((item) =>
              item?.venueName.toLowerCase().includes(searchVenue.toLowerCase())
            )
            .map((item, index) => (
              <Box
                onClick={() => {
                  handleVenueClick(item, index);
                }}
                className={`card ${selectedId === index ? "bg-main text-light" : "bg-light-main"
                  } text-start w-100 p-2 border-10 mb-3 ms-0`}
                key={index}>
                <Typography fontWeight={"bold"}>{item?.venueName}</Typography>
              </Box>
            ))}
        </Grid>
        {(selectedId !== null && venuelist && venueData) && (
          <Grid
            size={{ xs: 12, md: 8 }}
            className="h-100 p-3 border-10"
            border={"1px solid #ccc"}>
            <Grid
              container
              spacing={2}
              height={"fit-content"}
              position={"relative"}
              overflow={"auto"}>
              {/* 🔹 Venue Info Section with Accordion */}
              <Accordion defaultExpanded className="mb-3 w-100">
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Grid size={10}>
                    <Typography variant="h5" className="fw-bold" mb={1}>
                      {venuelist?.[selectedId]?.venueName}
                    </Typography>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={2}
                    sx={{ height: 'fit-content' }}>
                    {/* Venue Name */}
                    <Grid size={6}>
                      <TextField
                        fullWidth
                        label="Site Name"
                        value={venueData?.venueName}
                        onChange={(e) =>
                          handleVenueChange("venueName", e.target.value)
                        }
                        InputLabelProps={{
                          shrink: true
                        }}
                        style={{ marginTop: "10px" }}
                      />
                    </Grid>

                    {/* Region */}
                    <Grid size={6}>
                      <TextField
                        fullWidth
                        select
                        label="Region"
                        value={venueData?.regionId?.regionId || ""}
                        onChange={(e) => {
                          const selectedRegion = regionBusiness.find(
                            (region: any) => region.regionId === e.target.value
                          );
                          handleVenueChange("regionId", selectedRegion);
                        }}
                        InputLabelProps={{ shrink: true }}
                        style={{ marginTop: "10px" }}
                      >
                        {regionBusiness?.map((region: any) => (
                          <MenuItem key={region.regionId} value={region.regionId}>
                            {region.regionName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* Director */}
                    <Grid size={6}>
                      <TextField
                        fullWidth
                        label="Director"
                        value={venueData?.directorName}
                        onChange={(e) =>
                          handleVenueChange("directorName", e.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                        style={{ marginTop: "10px" }}
                      />
                    </Grid>

                    {/* Zone (Radio) */}
                    <Grid size={6}>
                      <FormControl component="fieldset" fullWidth>
                        <FormLabel component="legend">Zone</FormLabel>
                        <RadioGroup
                          row
                          value={venueData?.locationType}
                          onChange={(e) =>
                            handleVenueChange("locationType", e.target.value)
                          }>
                          <FormControlLabel
                            value="region"
                            control={<Radio />}
                            label="Regional"
                          />
                          <FormControlLabel
                            value="city"
                            control={<Radio />}
                            label="Metro"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Address */}
                    <Grid size={12}>
                      <TextField
                        inputRef={inputRef}
                        fullWidth
                        multiline
                        label="Address"
                        value={venueData?.address}
                        onChange={(e) =>
                          handleVenueChange("address", e.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>

                    {/* Lat & Long */}
                    <Grid size={6}>
                      <TextField
                        fullWidth
                        label="Latitude"
                        value={venueData?.lat}
                        onChange={(e) =>
                          handleVenueChange("lat", e.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid size={6}>
                      <TextField
                        fullWidth
                        label="Longitude"
                        value={venueData?.long}
                        onChange={(e) =>
                          handleVenueChange("long", e.target.value)
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>

                    {isLoaded ? (
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={{
                          lat: Number(venueData?.lat) || center.lat,
                          lng: Number(venueData?.long) || center.lng,
                        }}
                        options={{
                          disableDefaultUI: true,   // hides all default UI controls
                          draggable: false,         // disables map dragging
                          zoomControl: false,       // disables zoom control buttons
                          scrollwheel: false,       // disables zoom with scroll
                          disableDoubleClickZoom: true, // disables zoom on double click
                          keyboardShortcuts: false, // disables keyboard movement
                        }}

                        zoom={15}>
                        <Marker
                          position={{
                            lat: Number(venueData?.lat) || center.lat,
                            lng: Number(venueData?.long) || center.lng,
                          }}
                        />
                      </GoogleMap>
                    ) : (
                      <div>Loading map...</div>
                    )}

                    {/* Liquor */}
                    {storage.getItem("ClientGroupName")?.toUpperCase() === "ALDI" && (
                      <Grid size={6}>
                        <TextField
                          fullWidth
                          select
                          label="Liquor"
                          value={venueData?.isAldiLiquor ? "Yes" : "No"}
                          onChange={(e) =>
                            handleVenueChange(
                              "isAldiLiquor",
                              e.target.value === "Yes"
                            )
                          }>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </TextField>
                      </Grid>
                    )}

                    <Grid size={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={venueData?.isActive || false}
                            onChange={(e) =>
                              handleVenueChange("isActive", e.target.checked)
                            }
                          />
                        }
                        label="Is site currently active"
                      />
                    </Grid>

                    {/* Open / Close Hours */}
                    <Grid size={6}>
                      <TextField
                        fullWidth
                        label="reopenDate"
                        type="date"   // ⬅️ datetime input
                        value={formatDateTimeLocal(venueData?.venueOpen)}
                        onChange={(e) =>
                          handleVenueChange("venueOpen", e.target.value)
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid size={6}>
                      <TextField
                        fullWidth
                        label="closureDate"
                        type="date"   // ⬅️ datetime input
                        value={formatDateTimeLocal(venueData?.venueClose)}
                        onChange={(e) =>
                          handleVenueChange("venueClose", e.target.value)
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{ mt: 1 }}
                      />
                    </Grid>


                    {/* ✅ Active Checkbox */}

                  </Grid>

                  <Button
                    className="btn-main mb-1 mt-3"
                    variant="contained"
                    size="small"
                    sx={{ ml: 2 }}
                    onClick={() => handleSaveVenue(venueData)}>
                    Save Details
                  </Button>
                </AccordionDetails>
              </Accordion>

              {/* 🔹 Sticky Header with Venue Managers */}
              <Grid
                size={12}
                bgcolor={"white"}
                position={"sticky"}
                top={0}
                zIndex={99}>
                <Grid container>
                  <Grid size={10}>
                    <Typography variant="h5" className="fw-bold" mb={1}>
                      Site Managers
                    </Typography>
                  </Grid>
                  <Grid size={2}>
                    <Box className="d-flex justify-content-end">
                      <Button
                        className="btn-main mb-1"
                        onClick={() => {
                          setisOpenAdd(true);
                        }}>
                        + Add New
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* 🔹 Venue Managers */}
              {venuemanagerlist.map((item, index) => (
                <Grid
                  size={'grow'}
                  height={"fit-content"}
                  className="card text-start p-1 px-3 border-10 mb-0 ms-0"
                  key={index}>
                  <Box className="d-flex align-items-center justify-content-between">
                    <Typography className="col-8 px-0">
                      {item?.displayName}
                    </Typography>
                    <Box className='d-flex col-3  justify-content-end'>
                      <IconButton
                        className="px-0"
                        onClick={() => {
                          setisOpenAdd(true);
                          setisedit(true);
                          setselectedmanager(index);
                        }}>
                        <Edit />
                      </IconButton>
                      {/* <Button className="btn-main px-5" onClick={() => {navigateToLoginShopper(item)}}>Login</Button> */}
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}
      </Grid>
      <Drawer
        anchor="right"
        PaperProps={{
          sx: { width: "100%", maxWidth: "500px" },
        }}
        open={isOpenAdd}>
        <Box className="p-3 bg-white h-100 w-100">
          <Box className={"d-flex allign-items-center justify-content-between"}>
            <Typography variant="h5" className="mb-0" fontWeight={"bolder"}>
              {isedit ? 'Edit Site Manager' : 'Add Site Manager'}
            </Typography>
            <IconButton
              onClick={() => {
                setisOpenAdd(false);
                setisedit(false);
              }}>
              <CancelOutlined />
            </IconButton>
          </Box>
          <hr />
          <form className="w-100" onSubmit={formik.handleSubmit}>
            <Grid container spacing={2} className="w-100">
              <Grid size={12}>
                <FormControl className="rm-padding w-100">
                  <FormLabel sx={{ fontSize: "14px" }}>First Name</FormLabel>
                  <TextField
                    name="firstName"
                    className="w-100 border-20"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.firstName &&
                    formik.errors.firstName &&
                    typeof formik.errors.firstName === "string" && (
                      <Typography variant="caption" sx={{ color: "red" }}>
                        {formik.errors.firstName}
                      </Typography>
                    )}
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControl className="rm-padding w-100">
                  <FormLabel sx={{ fontSize: "14px" }}>Last Name</FormLabel>
                  <TextField
                    name="lastName"
                    className="w-100 border-20"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.lastName &&
                    formik.errors.lastName &&
                    typeof formik.errors.lastName === "string" && (
                      <Typography variant="caption" sx={{ color: "red" }}>
                        {formik.errors.lastName}
                      </Typography>
                    )}
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControl className=" w-100 rm-padding">
                  <FormLabel sx={{ fontSize: "14px" }}>Manager Email</FormLabel>
                  <TextField
                    type="email"
                    name="emailId"
                    className="w-100 border-20"
                    value={formik.values.emailId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.emailId &&
                    formik.errors.emailId &&
                    typeof formik.errors.emailId === "string" && (
                      <Typography variant="caption" sx={{ color: "red" }}>
                        {formik.errors.emailId}
                      </Typography>
                    )}
                </FormControl>
              </Grid>
              <Grid size={12}>
                <FormControl className=" w-100 rm-padding">
                  <FormLabel sx={{ fontSize: "14px" }}>Contact</FormLabel>
                  <TextField
                    type="text"
                    name="contactNo"
                    className="w-100 border-20"
                    value={formik.values.contactNo}
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                      const onlyDigits = e.target.value.replace(/\D/g, "");
                      formik.setFieldValue("contactNo", onlyDigits);
                    }}
                    inputProps={{
                      maxLength: 10,
                    }}
                  />
                  {formik.touched.emailId &&
                    formik.errors.contactNo &&
                    typeof formik.errors.contactNo === "string" && (
                      <Typography variant="caption" sx={{ color: "red" }}>
                        {formik.errors.contactNo}
                      </Typography>
                    )}
                </FormControl>
              </Grid>
              {!isedit && (
                <>
                  <Grid size={12}>
                    <FormControl className="w-100 rm-padding">
                      <FormLabel sx={{ fontSize: "14px" }}>
                        Create Password
                      </FormLabel>
                      <TextField
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="w-100 border-20"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.password &&
                        formik.errors.password &&
                        typeof formik.errors.password === "string" && (
                          <Typography variant="caption" sx={{ color: "red" }}>
                            {formik.errors.password}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid size={12}>
                    <FormControl className="w-100 rm-padding">
                      <FormLabel sx={{ fontSize: "14px" }}>
                        Confirm Password
                      </FormLabel>
                      <TextField
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmpassword"
                        className="w-100 border-20"
                        value={formik.values.confirmpassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                                edge="end">
                                {showConfirmPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formik.touched.confirmpassword &&
                        formik.errors.confirmpassword &&
                        typeof formik.errors.confirmpassword === "string" && (
                          <Typography variant="caption" sx={{ color: "red" }}>
                            {formik.errors.confirmpassword}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
            <Box className="d-flex justify-content-end">
              <Button type="submit" className="btn-main px-4 py-1 my-3">
                {isedit ? "Update" : "Add"}
              </Button>
            </Box>
          </form>
        </Box>
      </Drawer>
    </Box>
  );
}

export default ManageVenue;
